module.exports = __webpack_public_path__ + "files/9719524b1bed6be9e69fe7cc6be2a8a4.png";